
import { Step } from "@/lib/types";

export const introductionStep: Step = {
  id: "introduction",
  type: "step",
  title: "Welcome to Cray Cray Reposters!",
  description: `
  Hello and welcome!

  We're so happy to start working with you.

  You'll work with Cray Cray, the #1 communication app for couples.

  The job is simple: all you have to do is create a new Tiktok account and repost our content in the US.

  We target 18-30 girls who're in a relationship in the US.

  Please check our app: https://craycray.onelink.me/oZv9/o8hhmhew.

  → We're willing to work with the same persons **over the long term**.

  → There's no micromanagement here — we're looking for people who can understand instructions and follow the process with **complete autonomy**. Your efforts will be rewarded!

  → We wish to build a win-win relationship between you as an individual and Cray Cray.

  Please read the process below carefully, as it contains all the informations to work with us.

  If you have questions, feel free to ask our CEO Théo on WhatsApp: +33607379887. All our primary discussions shall remain on UpWork.
  `,
  buttonText: "Start my onboarding"
};
